import type { Dispatch, SetStateAction } from 'react'
import { ERROR_MESSAGES } from 'utils/constants'

export interface OnSubmitGenericModalProps {
  comment?: string
}

export interface FieldsSettingsProps {
  hasCommentField: boolean
  isCommentRequiredField: boolean
}
export const defaultFieldsSettings: FieldsSettingsProps = {
  hasCommentField: false,
  isCommentRequiredField: false,
}

const { MANDATORY_FIELD } = ERROR_MESSAGES

export const handleInputChange = (
  setter: (value: string) => void | Dispatch<SetStateAction<string>>,
  errorSetter: Dispatch<SetStateAction<string | undefined>>,
  value: string,
  isRequired: boolean,
) => {
  errorSetter(isRequired && !value ? MANDATORY_FIELD : undefined)
  setter(value)
}
